module.exports = __webpack_public_path__ + "static/business-edfcd8e4dfbabb585bef50c3f7ce7fd5.jpg";